var map = {
	"./armor.png": 2073,
	"./arms.png": 7598,
	"./ball.png": 6905,
	"./blob.png": 6688,
	"./bug-wings.png": 6107,
	"./fish.png": 7826,
	"./heads.png": 4921,
	"./humanoid.png": 677,
	"./legs.png": 7417,
	"./quadruped.png": 7209,
	"./squiggle.png": 23,
	"./tentacles.png": 9837,
	"./upright.png": 6150,
	"./wings.png": 1602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7678;